import axios from 'axios';
import { getActivityLogEndpoint } from '../../../libs/RestAPIRoutes';

let initialState = {
  activitylogs: {},
  selected: null,
  total: 0,
  page: 0
};


const ActivityLogReducer = (state=initialState, action) => {

  const payload = action.payload

  switch (action.type) {

    case 'ACTIVITYLOG_SELECTED': {
      console.log('ACTIVITYLOG_SELECTED')

      return {
        ...state,
        selected: payload.id
      }
    }

    case 'ACTIVITYLOG_SAVE': {
      console.log('ACTIVITYLOG_SAVE')
      console.log(payload)
      //activitylogs : Object.assign({}, state.activitylogs, ...payload.results.map((ele) => ({[ele.id]: ele })))
   
      return {
        ...state,
        total: payload.total,
        page: payload.page,
        activitylogs : Object.assign({}, ...payload.results.map((ele) => ({[ele.id]: ele })))
      }
    }

    default:
      return state
  }
};


export const activitylog_save = (data) => ({ type: 'ACTIVITYLOG_SAVE', payload: data })
export const activitylog_selected = (data) => ({ type: 'ACTIVITYLOG_SELECTED', payload: data });


export const ajaxfetchActivityLog = async (page) => {
    const querystring = `?page=${page}`
    const response =  await axios.get(`${getActivityLogEndpoint()}${querystring}`);
    return response
}


export default ActivityLogReducer;
